<div class="my-3 my-md-5">
    <div class="container-fluid">
        <div class="col-sm-6 float-left">
            <h1 class="page-title">Lab List</h1>
        </div>
        <div class="col-sm-6 float-left add_user_btn" *ngIf="myrole=='1' || myrole=='17' ">
            <a routerLink="/create-lab" class="btn btn-success">
                <i class="fa fa-plus" aria-hidden="true"></i> Add New Lab
            </a>
        </div>

    </div>
    <div class="container-fluid px-4 pt-4 card">
        <mat-accordion class="example-headers-align" multi>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row mb-4 mt-4">
                    <div class="col-sm-3"><input class="form-control" [(ngModel)]="search" type="text"
                            (keyup)="loadLabList(0,perpage)" placeholder="Search" /></div>

                    <div class="col-sm-3">
                        <mat-select placeholder="Circle" (selectionChange)="loadLabList(0,perpage)" [(ngModel)]="circle"
                            (click)="setSearchValue()">
                            <input class="mySearchInput" #circleSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'circle')"
                                (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                id="circleSearch">
                            <mat-option>All</mat-option>
                            <mat-option value="{{cir.id}}" *ngFor="let cir of circles">{{cir.name}}</mat-option>
                        </mat-select>
                    </div>
                    <div class="col-sm-3">
                        <mat-select placeholder="Status" (selectionChange)="loadLabList(0,perpage)"
                            [(ngModel)]="status">
                            <mat-option>All</mat-option>
                            <mat-option value="1">Active</mat-option>
                            <mat-option value="0">In-Active</mat-option>
                        </mat-select>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
        <div class="card">
            <div class="container-fluid row">
                <div class="col-sm-6 p-3"><button type="button" class="btn btn-success" [disabled]="loading"
                        (click)="loadLabList(0,perpage)"><i class="fa fa-sync" [ngClass]="{'fa-spin':loading}"></i>
                        Refresh List</button>

                </div>
                <div class="col-sm-6">
                    <mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions"
                        [pageSize]="perpage"
                        (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex">
                    </mat-paginator>
                </div>
            </div>
            <div class="tableFixHead" style="overflow: scroll">
                <table class="table table-striped hospitalTable">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th class="tablefixcoloumn">Name</th>
                            <th>Contact Number</th>
                            <th>Circle</th>
                            <th>City</th>
                            <th>Status</th>
                            <th *ngIf="myrole=='1' || myrole=='17'">Active/In-Active</th>
                            <th *ngIf="myrole=='1' || myrole=='17' ">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let lab of labList;let index = index;">
                            <td>{{(pageIndex*perpage)+index+1}}</td>
                            <td class="tablefixcoloumn">{{lab.name}}</td>
                            <td>{{lab.mobile}}</td>
                            <td>{{lab.circle_name}}</td>
                            <td>{{lab.cityName}}</td>
                            <td>
                                <span class="badge bg-green-light" *ngIf="lab.status=='1'">Active</span>
                                <span class="badge bg-azure-light" *ngIf="lab.status=='0'">In-Active</span>
                            </td>


                            <td *ngIf="myrole=='1' || myrole=='17'">
                                <mat-slide-toggle [checked]="lab.status=='1'"
                                    (change)="onStatusChange($event,lab.id,index)"></mat-slide-toggle>
                            </td>
                            <td *ngIf="myrole=='1' || myrole=='17' ">
                                <div class="dropdown">
                                    <button class="btn btn-secondary dropdown-toggle" type="button" id="{{lab.id}}"
                                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        Action
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="{{lab.id}}">
                                        <a *ngIf="myrole=='1'  || myrole=='17' " class="dropdown-item"
                                            routerLink="/update-lab/{{lab.id}}"><i class="fa fa-pen"></i> Update</a>

                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr *ngIf="loading">
                            <td colspan="20" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                        </tr>
                        <tr *ngIf="loaded && !labList.length">
                            <td colspan="20"><i class="far fa-frown"></i> Lab not found</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage"
                (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
        </div>
    </div>
</div>